import React from 'react'

const Input = (props: any) => {
	return (
		<div className={props.className}>
			<label className="label-input" htmlFor={props.id}>
				{props.label}
			</label>
			{props.symbol!}
			<input
				{...props}
				className={
					props.error ? 'input-form input-error' : 'input-form'
				}
			/>
			{props.error && (
				<label className="error-message">{props.error}</label>
			)}
		</div>
	)
}
export default Input
